import { httpClient } from '@/main';

export async function getPromoCode() {
  return await httpClient.get('/checkout/order/GetPromoCode');
}
